import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import ChatRestServices from '../../services/chat-rest.service';

@Component({
	standalone: true,
	selector: 'modal-chatbot-summary',
	templateUrl: './modal-chatbot-summary.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class ModalChatbotSummaryComponent implements OnInit {
	private chatRestServices: ChatRestServices = inject(ChatRestServices);
	private dialogRef = inject(MatDialogRef<ModalChatbotSummaryComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		if (!this.vm.summary) {
			this.getBotSummary();
		}
		
		this.vm.close = this.close;
	}
	
	getBotSummary() {
		this.chatRestServices.getBotSummary({chatId: this.vm.chatId},
			(res) => {
				this.vm.summary = res.summary;
			},
			(err) => {
				console.log(err);
			});
	}
	
	copySummary(): void {
	    if (navigator.clipboard && this.vm.summary) {
	        navigator.clipboard.writeText(this.vm.summary).then(() => {
				// ignore
	        }).catch(err => {
	            console.error('Could not copy text: ', err);
	        });
	    }
	}
	
	close() {
		this.dialogRef.close();
	}
	
}